import React from "react";
import { useNavigate } from "react-router-dom";
import { FiGift } from "react-icons/fi";
import styles from "./ActionCards.module.scss";

interface LootBoxCardProps {
    onModalOpen?: () => void;
    onModalClose?: () => void;
}

/**
 * LootBox Action Card - Promotes DevourPlay LootBoxes
 * Major revenue driver - direct navigation to purchase flow
 */
const LootBoxCard: React.FC<LootBoxCardProps> = ({
    onModalOpen,
    onModalClose,
}) => {
    const navigate = useNavigate();

    const handleLootBoxClick = () => {
        navigate("/devourlootbox");
    };

    return (
        <div
            className="stat-card"
            onClick={handleLootBoxClick}
            style={{
                cursor: "pointer",
                backgroundImage: "url(/images/card-bck4.png)",
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                border: "1px solid rgba(214, 158, 46, 0.3)",
                boxShadow: "inset 0 1px 0 rgba(255, 255, 255, 0.1), 0 4px 12px rgba(0, 0, 0, 0.4), 0 0 0 1px rgba(214, 158, 46, 0.15)",
                position: "relative",
            }}
        >
            <div style={{
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                background: "rgba(0, 0, 0, 0.5)",
                borderRadius: "inherit",
            }}></div>
            <div style={{ position: "relative", zIndex: 1 }}>
                <h4 style={{ color: "white", textShadow: "0 2px 4px rgba(0, 0, 0, 0.9)", fontWeight: "700", letterSpacing: "0.5px" }}>🎁 LOOTBOXES</h4>
                <div className="stat-value" style={{ color: "#D69E2E", textShadow: "0 2px 4px rgba(0, 0, 0, 0.9)", fontWeight: "700", fontSize: "1.1rem" }}>OPEN</div>
                <div className="stat-subtitle" style={{ color: "rgba(255, 255, 255, 0.95)", textShadow: "0 1px 2px rgba(0, 0, 0, 0.9)", fontWeight: "500" }}>Yours Today</div>
            </div>
        </div>
    );
};

export default LootBoxCard;